/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BlockedTimeDialog/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import BlockedTimeHistory from './BlockedTimeHistory/index'
import DeleteAction from './DeleteAction/index'
import EditAction from './EditAction/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BlockedTimeDialog({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/BlockedTime/BlockedTimeDialog",
  isOpen,
  contentRef,
  left,
  top,
  onMouseEnter,
  onMouseLeave
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let eventScheduleNoteContentValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'schedule_note.content',
})
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={isOpen}>
<div
  data-testid="BlockedTimeDialog.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--l-1-Z1vVyA0': typeof left === 'number' ? `${left}px` : left,'--t-2-Z1vVyA0': typeof top === 'number' ? `${top}px` : top,'--bc-3-Z1vVyA0': dtColorsWhite,'--bc-4-Z1vVyA0': dtColorsNeutral300,'--btlr-5-Z1vVyA0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-Z1vVyA0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-7-Z1vVyA0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-8-Z1vVyA0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-9-Z1vVyA0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-10-Z1vVyA0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-11-Z1vVyA0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-12-Z1vVyA0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-13-Z1vVyA0': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 size="normal"
 width="medium"
 text="Blocked Time"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event.schedule_note.content"
 text={eventScheduleNoteContentValueData}
 weight="regular"
 size="normal"
 marginBottom={dtSpaceXs}
/>
<BlockedTimeHistory
  viewPath={`${viewPath}/BlockedTimeHistory`}
/>
<div
  data-testid="BlockedTimeDialog.Horizontal"
  data-view-path={viewPath}
 style={{'--g-13-Z1vVyA0': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<EditAction
  viewPath={`${viewPath}/EditAction`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
</div>
</fromFlow.When>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}